
import { useState, useEffect } from "react";

export default function FloatingContact() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 800);
    const pulseTimer = setInterval(() => {
      setPulse((p) => !p);
    }, 2000);
    return () => {
      clearTimeout(timer);
      clearInterval(pulseTimer);
    };
  }, []);

  return (
    <div
      className={`fixed right-5 bottom-24 z-[9999] flex flex-col items-center gap-3 transition-all duration-700 ${
        visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"
      }`}
    >
      {/* Zalo Button */}
      <div className="relative group flex flex-col items-center">
        {/* Tooltip */}
        <span className="absolute right-16 bg-gray-800 text-white text-xs font-semibold px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-lg">
          Chat Zalo
          <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 border-4 border-transparent border-l-gray-800"></span>
        </span>

        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#0068FF]/30 animate-ping"></span>
        <span className="absolute inset-[-4px] rounded-full bg-[#0068FF]/15 animate-ping" style={{ animationDelay: "0.4s" }}></span>

        <a
          href="https://zalo.me/0968947136"
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-14 h-14 rounded-full flex items-center justify-center shadow-xl cursor-pointer transition-transform duration-200 hover:scale-110 active:scale-95"
          style={{ background: "linear-gradient(135deg, #0068FF 0%, #0052CC 100%)" }}
          aria-label="Chat Zalo"
        >
          {/* Zalo icon using text */}
          <span className="text-white font-extrabold text-lg leading-none tracking-tight select-none">
            Zalo
          </span>
        </a>

        {/* Label */}
        <span className="mt-1 text-[10px] font-bold text-[#0068FF] bg-white/90 px-2 py-0.5 rounded-full shadow-sm whitespace-nowrap">
          Chat ngay
        </span>
      </div>

      {/* Call Button */}
      <div className="relative group flex flex-col items-center">
        {/* Tooltip */}
        <span className="absolute right-16 bg-gray-800 text-white text-xs font-semibold px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-lg">
          0968.947.136
          <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 border-4 border-transparent border-l-gray-800"></span>
        </span>

        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-green-500/30 animate-ping" style={{ animationDelay: "1s" }}></span>
        <span className="absolute inset-[-4px] rounded-full bg-green-500/15 animate-ping" style={{ animationDelay: "1.4s" }}></span>

        <a
          href="tel:0968947136"
          className="relative w-14 h-14 rounded-full flex items-center justify-center shadow-xl cursor-pointer transition-transform duration-200 hover:scale-110 active:scale-95"
          style={{ background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)" }}
          aria-label="Gọi ngay"
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className="ri-phone-fill text-white text-2xl"></i>
          </div>
        </a>

        {/* Label */}
        <span className="mt-1 text-[10px] font-bold text-green-600 bg-white/90 px-2 py-0.5 rounded-full shadow-sm whitespace-nowrap">
          Gọi ngay
        </span>
      </div>
    </div>
  );
}
